import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const RowDivider = () => { return (<Row><Col>&nbsp;</Col></Row>); }

export default RowDivider;
